import { render, staticRenderFns } from "./LeadSale.vue?vue&type=template&id=af2b369c"
import script from "./LeadSale.vue?vue&type=script&lang=js"
export * from "./LeadSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports